import script from "./AssignModuleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AssignModuleModal.vue?vue&type=script&setup=true&lang=js"

import "./AssignModuleModal.vue?vue&type=style&index=0&id=4bdd88c6&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bdd88c6"]])

export default __exports__